/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  gap: 20px;
  overflow: auto;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 14;
  color: ${({ theme }) => theme.textfield.text};
`;
Title.displayName = 'Title';
